import React from 'react';
import classNames from 'classnames';

type OverlaySectionHeadlineProps = {
  as?: keyof JSX.IntrinsicElements;
  children: React.ReactNode;
  className?: classNames.Argument;
};

export const OverlaySectionHeadline: React.FC<OverlaySectionHeadlineProps> = ({
  as: Tag = 'h3',
  children,
  className,
}) => {
  return <Tag className={classNames('typo-text-16--bold text-full mb-16', className)}>{children}</Tag>;
};
